import { bool, string } from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { DEFAULT_COLORS } from 'constants/colors';

const NotificationsCounterStyledV1 = styled.span`
    align-items: center;
    background: ${DEFAULT_COLORS.RED_3};
    border-radius: 9.5px;
    color: ${DEFAULT_COLORS.WHITE};
    display: flex;
    font-size: 0.6rem;
    font-weight: bold;
    justify-content: center;
    right: 5px;
    top: 0;
    position: absolute;
    min-width: 0.8rem;
    height: 0.8rem;
    padding: 5px 5px;
    object-fit: contain;
    ${({ value }) =>
        value > 9
            ? {
                  right: value > 99 ? '-5px' : 0,
              }
            : null}
`;

const NotificationsCounterStyledV2 = styled.span`
    align-items: center;
    background: #b53349;
    border-radius: 16px;
    color: ${DEFAULT_COLORS.WHITE};
    display: flex;
    font-family: 'Roboto', sans-serif;
    font-size: 10px;
    font-weight: 400;
    line-height: 10px;
    justify-content: center;
    text-align: center;
    position: absolute;
    top: -20px;
    right: -20px;
    min-width: 18px;
    min-height: 18px;
    padding: 2px 6px;
    box-sizing: border-box;
`;

function NotificationsCounter({ value, isNavigationV2Enabled }) {
    const NotificationsCounterStyled = isNavigationV2Enabled
        ? NotificationsCounterStyledV2
        : NotificationsCounterStyledV1;

    return (
        <NotificationsCounterStyled value={value}>
            {value > 99 ? '99+' : value}
        </NotificationsCounterStyled>
    );
}

NotificationsCounter.propTypes = {
    value: string,
    isNavigationV2Enabled: bool,
};

NotificationsCounter.defaultProps = {
    value: null,
    isNavigationV2Enabled: false,
};

export default NotificationsCounter;
